// Color tokens extracted from theme
export const colors = {
  // Primary colors
  primary: {
    main: "#13319a",
    light: "#4c91f7",
    lighter: "#ecf4ff",
    contrastText: "#fff",
  },

  // Secondary colors
  secondary: {
    main: "#e50b71",
    contrastText: "#fff",
  },

  // Text colors
  text: {
    primary: "#131313",
    helper: "#555555",
  },

  // Purple colors
  purple: {
    main: "#DDD5FF",
    light: "#F9E8FF",
    dark: "#520c6b",
    contrastText: "#131313",
  },

  // Yellow colors
  yellow: {
    main: "#dfb400",
    light: "#ffffb7",
    contrastText: "#131313",
  },

  // Black colors
  black: {
    main: "#131313",
    light: "#333",
    contrastText: "#fff",
  },

  // Success colors
  success: {
    main: "#BCFBC6",
    dark: "#18661e",
    border: "#10BA2B",
    contrastText: "#131313",
  },

  // Additional colors used in components
  white: "#fff",
  linkColor: "#e50b71",
  cookieConsentBg: "#fff",
  cookieConsentBorder: "#e0e0e0",
};
